export function trimAndReplaceSpaceWithDash(input: string): string {
    try {
        return input?.trim()?.replace(/\s+/g, "-")
    } catch (err) {
        return input
    }
}

export function capitalizeHyphenated(str: string): string {
    try {
        return str
            .split("-")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join("-").split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join("-");
    }
    catch (error) {
        return str
    }
}